/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MaterialReactTable } from "material-react-table";

import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { mergeListById } from "helper/Common/CommonHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { assetImages } from "constants";
import DeleteWarningModal from "components/Common/Modal/DeleteWarningModal";
import AssignUserModal from "components/Common/Modal/AssignUserModal";
import LabTestHeader from "./Header/LabTestHeader"; // Updated import
import SaveLabTestTemplatePopup from "./Popup/SaveLabTestTemplatePopup";

const LabTestTemplateBody = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [isLoading, setIsLoading] = useState(false);
  const [labTestList, setLabTestList] = useState([]); // Renamed
  const [rowSelection, setRowSelection] = useState({});
  const [selectedLabTestIds, setSelectedLabTestIds] = useState([]); // Renamed
  const [selectedLabTestId, setSelectedLabTestId] = useState(null); // Renamed

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  // get all lab tests
  const getAllLabTests = async () => {
    // Renamed
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MEDICAL_TEST_TEMPLATES +
        `?token=${token}`;

      console.log("requestUrl in lab test list------->", requestUrl);

      const response = await getData(requestUrl);

      setIsLoading(false);
      if (response.status) {
        setLabTestList(response.data); // Renamed
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // bulk update lab tests
  const updateBulkLabTestsHandler = async () => {
    // Renamed
    if (selectedLabTestIds.length > 0) {
      // Renamed
      try {
        const labTestListToBeUpdate = labTestList.filter(
          (
            item // Renamed
          ) => selectedLabTestIds.includes(item._id) // Renamed
        );

        let labTestData = {
          // Renamed
          medicaltestlist: labTestListToBeUpdate, // Renamed
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_UPDATE_BULK_MEDICAL_TEST +
          `?token=${token}`;

        const response = await putData(requestURL, labTestData); // Renamed

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedLabTestIds([]); // Renamed
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one lab test"); // Updated message
      setMessageType("error");
    }
    setShowAlert(true);
  };

  // bulk delete lab tests
  const deleteBulkLabTestsHandler = async () => {
    // Renamed
    if (selectedLabTestIds.length > 0) {
      // Renamed
      try {
        const labTestListToBeDelete = labTestList.filter(
          (
            item // Renamed
          ) => selectedLabTestIds.includes(item._id) // Renamed
        );

        let labTestData = {
          // Renamed
          medicaltestlist: labTestListToBeDelete, // Renamed
        };

        let requestURL =
          url.API_BASE_URL +
          url.API_DELETE_BULK_MEDICAL_TEST +
          `?token=${token}`;

        const response = await putData(requestURL, labTestData); // Renamed

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setLabTestList(
              (
                prevList // Renamed
              ) =>
                prevList.filter(
                  (item) => !selectedLabTestIds.includes(item._id)
                ) // Renamed
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setAlertMessage("Please select at least one lab test"); // Updated message
      setMessageType("error");
    }
    setShowAlert(true);
  };

  // After any action
  const afterActionClose = (data = []) => {
    setLabTestList((prevList) => mergeListById(prevList, data)); // Renamed
  };

  useEffect(() => {
    getAllLabTests(); // Renamed
  }, []);

  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: "Actions",
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveLabTestTemplateOffCanvas" // Updated target
            aria-controls="saveLabTestTemplateOffCanvas" // Updated target
            onClick={() => {
              setSelectedLabTestId(row.original._id); // Renamed
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        header: "Template Name",
        accessorKey: "name",
      },
      {
        header: "Code",
        accessorKey: "code",
      },
      {
        header: "Test Type",
        accessorKey: "categoryname",
      },
      {
        header: "Sample Type",
        accessorKey: "sampleType",
      },
      {
        header: "Parameter Count",
        accessorKey: "parameterscount",
      },
      {
        header: "Parameters",
        accessorKey: "parametersname",
      },
    ],
    []
  );

  const columnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ];

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedLabTestIds(selectedIdsArray); // Renamed
    } else {
      setSelectedLabTestIds([]); // Renamed
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            <LabTestHeader // Renamed
              selectedItemIds={selectedLabTestIds} // Renamed
              updateBulkHandler={updateBulkLabTestsHandler} // Renamed
              reloadList={getAllLabTests} // Renamed
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns}
                  data={labTestList} // Renamed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox in each row
                  getRowId={(row) => row._id}
                  onRowSelectionChange={setRowSelection}
                  state={{ rowSelection, columnOrder }}
                  initialState={{ rowSelection, columnOrder }} // to set the initial state of column order
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* popup and modals */}
          <SaveLabTestTemplatePopup
            selectedLabTestId={selectedLabTestId} // Renamed
            setSelectedLabTestId={setSelectedLabTestId} // Renamed
            afterActionClose={afterActionClose}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <AssignUserModal
            moduleName="medicaltest"
            afterModalClose={afterActionClose}
            selectedIds={selectedLabTestIds} // Renamed
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setRowSelection({});
              setSelectedLabTestIds([]); // Renamed
            }}
          />

          <DeleteWarningModal
            onDelete={deleteBulkLabTestsHandler} // Renamed
            onCancelDelete={() => {
              setRowSelection({});
              setSelectedLabTestIds([]); // Renamed
            }}
            moduleName={t("Lab Test")} // Updated module name
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default LabTestTemplateBody;
